import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Link from '../utils/link'
import he from 'he'
import Seo from '../components/seo'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Share, NextArrow, Email, Facebook, Twitter, LinkedIn } from '../components/icons'
import SubscribeForm from '../components/subscribe-form'
import ArticleCard from '../components/cards/article'
import VideoCard from '../components/cards/video'

class NewsArticleTemplate extends Component {

  state = {
    prevLabel: 'Prev',
    nextLabel: 'Next',
    shareLink: '',
    share: false,
  }

  componentDidMount() {
    this.setState({ shareLink: window.location.href })
    this.updateDimensions()
    this.loadFlippingBookScript();
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)

    // Remove the FlippingBook script when the component is unmounted
    const flippingBookScript = document.querySelector('script[src^="https://online.flippingbook.com"]');
    if (flippingBookScript) {
      flippingBookScript.remove();
    }
  }

  updateDimensions = () => {
    if(window.innerWidth < 900) {
      this.setState({
        prevLabel: 'Prev',
        nextLabel: 'Next',
      });
    } else {
      this.setState({
        prevLabel: 'Prev Article',
        nextLabel: 'Next Article',
      });
    }
  }

  // Helper function to conditionally load the FlippingBook script
  loadFlippingBookScript = () => {
    const flippingBookRegex = /<script[^>]*src="(https:\/\/online\.flippingbook\.com\/EmbedScriptUrl\.aspx[^"]*)"/;
    const content = this.props.data.wpPost.content;

    // Match the FlippingBook script URL in the content
    const match = content.match(flippingBookRegex);

    if (match) {
      const scriptSrc = match[1];

      // Check if the script is already appended
      if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
        const script = document.createElement('script');
        script.src = scriptSrc;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }
    }
  };

  scrollToID = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = window.innerWidth < 900 ? -100 : -116;
      const elPosition = el.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elPosition + offset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };


  render() {

    let post = this.props.data.wpPost
    let author = post.acf.author?.length > 0 ? post.acf.author[0] : null
    let tags = post?.tags?.nodes
    let articles = this.props.data.articles
    let { prevLabel, nextLabel, shareLink, share } = this.state
    const { nextPost, prevPost, latest } = this.props.data
    
    // Strip out the FlippingBook script from the content
    const contentWithoutScript = post.content.replace(/<script[^>]*src="https:\/\/online\.flippingbook\.com\/EmbedScriptUrl\.aspx[^>]*><\/script>/, '');

    return (
      <>
        <Seo title={he.decode(post.seo.title)} bodyClass={`single-post`} description={post.seo.metaDesc} image={post.featuredImage?.node?.sourceUrl} path={`/media-centre/${post.slug}`} />

        <article className='news-article'>

          <div className='news-article__inner'>

            <div className='news-article__content'>

              <div className='news-article__details'>
                
                <div className='news-article__heading'>
                  <span className='article-feature__tag'>{ post.categories.nodes[0].name }</span>
                  <h3 dangerouslySetInnerHTML={{ __html: post.title }} />
                  <p className='article-feature__date'>{ post.date}</p>
                </div>

                <div className='news-article__excerpt'>
                  <div className='news-article__excerpt-copy'>
                    { post.acf.excerpt && <div className='copy' dangerouslySetInnerHTML={{ __html: post.acf.excerpt }} /> }
                  </div>
                </div>
              
              </div>

              <div className='news-article__image'>
                <img loading='lazy' src={post?.featuredImage?.node?.sourceUrl} alt={post.title} />
              </div>

              <div className='news-article__share'>
                <ul className={share ? 'active' : ''}>
                  <li>
                    <Link to={`mailto:?body=${shareLink}`}>
                      <Email color="#FFFFFF" />
                    </Link>
                  </li>
                  <li>
                    <Link to={`//www.linkedin.com/shareArticle?mini=true&url=${shareLink}&title=${he.decode(post.title)}`}>
                      <LinkedIn color="#FFFFFF" />
                    </Link>
                  </li>
                  <li>
                    <Link to={`//www.facebook.com/sharer/sharer.php?u=${shareLink}`}>
                      <Facebook color="#FFFFFF" />
                    </Link>
                  </li>
                  <li>
                    <Link to={`//twitter.com/home?status=${shareLink}`}>
                      <Twitter color="#FFFFFF" />
                    </Link>
                  </li>
                </ul>
                <button onClick={() => this.setState({ share: !share })}>
                  <Share color="#FFFFFF" />
                </button>
                <p rel='button' onClick={() => this.setState({ share: !share })}>Share</p>
              </div>

            </div>

          </div>  

          <div className='news-article__body'>

              <div className='news-article__inner'>

                <div className='news-article__body-content'>  

                  <div className='news-article__body-details'> 

                    <div className='news-article__main'>

                      <div className='news-article__menu'>

                        <div className='news-article__sticky'>

                          { post.acf.readTime &&
                            <ul>
                              <li>{ post.acf.readTime }</li>
                            </ul>
                          }
                          { post.acf.navigation?.length > 0 &&
                            <ul className='news-article__navigation'>
                              { post.acf.navigation.map((el, i) => (
                                <li key={i}><button onClick={() => this.scrollToID(el.id)}>{ el.title }</button></li>
                              )) }
                            </ul>
                          }
                        </div>

                      </div>

                      <div className='copy' dangerouslySetInnerHTML={{ __html: contentWithoutScript }} />

                    </div>

                    { author &&

                      <div className='news-article__authors'>

                        <div className='news-article__menu'>

                          <ul>
                            <li>Author</li>
                          </ul>

                        </div>

                        <div className='news-article__author'>

                            <div className='news-article__thumbnail'>
                              <img loading='lazy' src={author?.acf?.thumbnailImage?.sourceUrl} alt={post.title} />
                            </div>

                            <div className='news-article__position'>

                              <ul>
                                <li className='author'>{ author.title }</li>
                              </ul>
                              { author.slug !== 'kollosche-marketing' &&
                                <div className='news-article__link'>
                                  <Link className='btn' to={`/team/${author.slug}/`}>View Profile</Link>
                                </div>
                              }

                            </div>

                          </div>

                      </div>
                  }
                  { !author && post.acf.externalAuthor?.name &&

                    <div className='news-article__authors'>

                      <div className='news-article__menu'>

                        <ul>
                          <li>Author</li>
                        </ul>

                      </div>

                      <div className='news-article__author'>

                          <div className='news-article__thumbnail'>
                            <img loading='lazy' src={post?.acf?.externalAuthor?.image?.sourceUrl} alt={post?.acf?.externalAuthor?.name} />
                          </div>

                          <div className='news-article__position'>

                            <ul>
                              <li className='author'>{ post?.acf?.externalAuthor?.name }</li>
                              <li className='position'>{ post?.acf?.externalAuthor?.position }</li>
                            </ul>

                          </div>

                        </div>

                    </div>
                  }

                  { tags.length > 0 && 

                    <div className='news-article__tags'>

                      <div className='news-article__menu'>

                        <ul>
                          <li>Tagged</li>
                        </ul>

                      </div>

                      <div className='news-article__tag'>

                        <ul>
                          { tags.map((el, i) => (
                            <li><span>{ el.name }</span></li>
                          ) ) }
                        </ul>

                      </div>

                    </div>

                  }

                  </div>

                  <div className='news-article__side-menu'>

                      { post.acf.relatedTv?.length > 0 &&
                        <div className='news-article__related-tv'>
                          <h4>Related KTV</h4>
                          { post.acf.relatedTv.map((el, i) => (
                            <div className='tv-grid__item' key={i}>
                              <VideoCard {...el} />
                            </div>
                          )) }
                        </div>
                      }

                      <div className='news-article__body-form'>

                        <h4>Subscribe to Kollosche news</h4>

                        <div className='subscribe-news'>
                          Our extensive network and award winning reputation across NSW and QLD ensures we have access to the best listings and insights. Make sure you never miss an update.
                        </div>

                        <SubscribeForm />

                      </div>

                  </div>

                </div>

              </div>

          </div>

          <div className='news-article__footer'>
            <div className='news-article__inner'>
              { latest?.nodes?.length &&
                <div className='news-article__articles'>
                  { latest.nodes.map((el, i) => (
                    <ArticleCard { ...el } key={i} />
                  ))}
                </div>
              }
              <div className='news-article__articles-buttons'>
                <ul>
                  <li className='prev-list'>
                    <Link to={`/media-centre/${ prevPost.slug }/`}>
                      {prevLabel}
                      <NextArrow color='#FFFFFF' />
                    </Link>
                  </li>
                  <li className='next-list'>
                    <Link to={`/media-centre/${ nextPost.slug }/`}>
                      <NextArrow color='#FFFFFF' />
                      {nextLabel}
                    </Link>
                  </li>
                </ul>
              </div>
            </div> 
          </div>

        </article>

      </>
    )
  }
}

export const profileQuery = graphql`
  query ($id: String!, $prev: String!, $next: String!) {
    latest: allWpPost(sort: {date: DESC}, limit: 2) {
      nodes {
        slug
        title
        date
        categories {
          nodes {
            slug
            name
          }
        }
        featuredImage {
          node {
            sourceUrl
            altText
          }
        }
      }
    }
    prevPost: wpPost(id: {eq: $prev}) {
      slug
    }
    nextPost: wpPost(id: {eq: $next}) {
      slug
    }
    wpPost(id: {eq: $id}) {
      title
      slug
      date(formatString: "MMMM D YYYY")
      content
      excerpt
      seo {
        ...WpSeo
      }
      categories {
        nodes {
          slug
          name
        }
      }
      tags {
        nodes {
          name
          slug
        }
      }
      featuredImage {
        node {
          sourceUrl
          altText
        }
      }
      acf {
        readTime
        excerpt
        navigation {
          title
          id
        }
        relatedTv {
          ... on WpVideo {
            title
            slug
            featuredImage {
              node {
                sourceUrl
                altText
              }
            }
            acf {
              categories
              tags
              video
            }
          }
        }
        author {
          ... on WpTeamMember {
            title
            slug
            acf {
              thumbnailImage {
                altText
                sourceUrl
              }
            }
          }
        }
        externalAuthor {
          image {
            sourceUrl
          }
          name
          position
        }
      }
    }
  }
`

export default NewsArticleTemplate
